const isAdmin = (user) => {
  if (user === undefined || user === null) return false;
  return user["cognito:groups"]?.includes("Admin");
};

export { isAdmin };
